import { render, staticRenderFns } from "./SupplyDemandView.vue?vue&type=template&id=cbef8108&scoped=true"
import script from "./SupplyDemandView.vue?vue&type=script&lang=js"
export * from "./SupplyDemandView.vue?vue&type=script&lang=js"
import style0 from "./SupplyDemandView.vue?vue&type=style&index=0&id=cbef8108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef8108",
  null
  
)

export default component.exports